import { render } from "./PRModal.vue?vue&type=template&id=07acbacd"
import script from "./PRModal.vue?vue&type=script&lang=js"
export * from "./PRModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__